export default "__VITE_ASSET__C6N_Oo4E__"